"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _leaflet = require("leaflet");

var _reactLeaflet = require("react-leaflet");

require("leaflet-rotatedmarker");

/**
 * @see https://github.com/verdie-g/react-leaflet-rotatedmarker/issues/1
 * TODO: maybe move to either base-map and/or utils and/or own npm & repo
 */
class RotatedMarker extends _reactLeaflet.MapLayer {
  createLeafletElement(props) {
    const el = new _leaflet.Marker(props.position, this.getOptions(props));
    this.contextValue = { ...props.leaflet,
      keyboard: props.keyboard,
      popupContainer: el
    };
    return el;
  }

  updateLeafletElement(fromProps, toProps) {
    if (toProps.position !== fromProps.position) {
      this.leafletElement.setLatLng(toProps.position);
    }

    if (toProps.icon !== fromProps.icon) {
      this.leafletElement.setIcon(toProps.icon);
    }

    if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
      this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
    }

    if (toProps.opacity !== fromProps.opacity) {
      this.leafletElement.setOpacity(toProps.opacity);
    }

    if (toProps.draggable !== fromProps.draggable) {
      if (toProps.draggable === true) {
        this.leafletElement.dragging.enable();
      } else {
        this.leafletElement.dragging.disable();
      }
    }

    if (toProps.rotationAngle !== fromProps.rotationAngle) {
      this.leafletElement.setRotationAngle(toProps.rotationAngle);
    }

    if (toProps.rotationOrigin !== fromProps.rotationOrigin) {
      this.leafletElement.setRotationOrigin(toProps.rotationOrigin);
    }
  }

  render() {
    const {
      children
    } = this.props;
    return children == null || this.contextValue == null ? null : /*#__PURE__*/_react.default.createElement(_reactLeaflet.LeafletProvider, {
      value: this.contextValue
    }, children);
  }

}

RotatedMarker.defaultProps = {
  keyboard: false,
  rotationOrigin: "center"
};

var _default = (0, _reactLeaflet.withLeaflet)(RotatedMarker);

exports.default = _default;
//# sourceMappingURL=index.js.map